module.exports = __webpack_public_path__ + "img/heldenContractSwoosh.6d4613d9.png";